import { api } from '@marketplace-web/core-api/core-api-client-util'

import { EducationType } from '../constants/education'

export const markEducationAsRead = (type: EducationType) => api.post('/user/education', { type })
